import {
  INDEX_BY_ORDER_TAB,
  ORDER_TAB_BY_INDEX,
  OrderTab,
} from '@src/orders/domain/OrderTab';
import { FIRST_PAGE } from '@src/orders/hooks/useCurrentPage';
import { Navigation } from '@src/routing/Navigation';
import { useSearchParams } from 'react-router-dom';

export const useCurrentTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTabIndex = Number(
    searchParams.get(Navigation.orderList.tabSearchParamKey) ??
      INDEX_BY_ORDER_TAB[OrderTab.New],
  );
  const currentTab = ORDER_TAB_BY_INDEX[currentTabIndex];

  const setCurrentTab = (tab: OrderTab) => {
    searchParams.set(
      Navigation.orderList.tabSearchParamKey,
      INDEX_BY_ORDER_TAB[tab].toString(),
    );
    setSearchParams(searchParams);
  };

  const setCurrentTabAndPage = (tab: OrderTab, page: number) => {
    searchParams.set(
      Navigation.orderList.tabSearchParamKey,
      INDEX_BY_ORDER_TAB[tab].toString(),
    );
    searchParams.set(Navigation.orderList.pageSearchParamKey, page.toString());
    setSearchParams(searchParams);
  };

  const setCurrentTabOnFirstPage = (tab: OrderTab) => {
    searchParams.set(
      Navigation.orderList.tabSearchParamKey,
      INDEX_BY_ORDER_TAB[tab].toString(),
    );
    searchParams.set(
      Navigation.orderList.pageSearchParamKey,
      FIRST_PAGE.toString(),
    );
    setSearchParams(searchParams);
  };

  return {
    currentTab,
    setCurrentTab,
    setCurrentTabAndPage,
    setCurrentTabOnFirstPage,
  };
};
